import { Box, Typography, Alert, LinearProgress } from '@mui/material'
import { useFarmId } from '../../common/use-farm-id'

function CropTemplates() {
  const { farmId, loading } = useFarmId()

  if (loading) {
    return (
      <Box sx={{ width: '100%', mt: 2 }}>
        <LinearProgress />
      </Box>
    )
  }

  if (!farmId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">
          Please select a farm to view crop templates
        </Alert>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Crop Templates for Farm {farmId}</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Crop Templates content coming soon...
      </Typography>
      <Typography>
        Or- maybe these should be under the user!
      </Typography>
    </Box>
  )
}

export default CropTemplates
